<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "SupplierComponent",
};
</script>

<style scoped></style>
